module.exports = __webpack_public_path__ + "img/truck.882d83ad.svg";